
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class StoneWIPStockBagWiseGrid extends Serenity.EntityGrid<WIPTransactionRow, any> {

        protected getColumnsKey() { return 'Production.WIPTransactionStone'; }
        protected getDialogType() { return WIPTransactionDialog; }
        protected getIdProperty() { return WIPTransactionRow.idProperty; }
        protected getLocalTextPrefix() { return WIPTransactionRow.localTextPrefix; }
        protected getService() { return WIPTransactionBagWiseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            (this.view.params as TransactionRequest).ItemTypeId = 105;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            //grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            //this.view.setGrouping([{

            //    //formatter: g => {
            //    //    return "<span class='slick-group-title-header'>" +
            //    //        g.value + " <span style='font-weight: bold;text-align: right;float:right;'>" +
            //    //        g.totals.sum.Weight.toFixed(3) + "</span></span>";
            //    //},
            //    getter: 'BagNo',

            //    displayTotalsRow: false,
            //    aggregators: [
            //        new Slick.Aggregators.Sum('Weight')
            //    ]
            //}])
            //this.view.setSummaryOptions({
            //    aggregators: [
            //        new Slick.Aggregators.Sum('PureWeight')]
            //});

            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Stone WIP Stock(Bag Wise)"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}